<div class="vl-agenda-item kl-invoice-card">
    <h3 class="vl-agenda-item__title">
        {{DateUtil().formatDate(invoiceCard.submitTimestamp)}} - {{invoiceCard.documentReference}}
    </h3>
    <div class="vl-agenda-item__text">
        {{invoiceCard.paymentType}}
    </div>
    <div class="vl-agenda-item__note" v-if="invoiceCard.customerReference">
        {{invoiceCard.customerReference}}
    </div>
    <div class="kl-invoice-card__price-row">
        <div class="vl-agenda-item__title" v-if="invoiceCard.totalPriceFormatted">
            <div v-if="!invoiceCard.isTopUpCredit">{{invoiceCard.totalPriceFormatted}}</div>
            <div v-else class="topUp">+ {{invoiceCard.totalPriceFormatted}}</div>
        </div>
        <div class="kl-invoice-card__price-row__right">
            <vl-link v-if="invoiceCard.invoicePdfUrl" :href="invoiceCard.invoicePdfUrl" hidden-text="Download als PDF"
                     mod-button mod-tertiary mod-icon-after icon="file-office-doc">
                PDF
            </vl-link>
            <vl-link v-if="invoiceCard.attachmentCsvUrl" :href="invoiceCard.attachmentCsvUrl" hidden-text="Download als CSV"
                     mod-button mod-tertiary mod-icon-after icon="file-office-xls">
                CSV
            </vl-link>
        </div>
    </div>
</div>
<vl-u-spacer mod-xsmall />
